module.exports = __webpack_public_path__ + "static/ms-teams-cc34c929300b50db7b9026887d721902.svg";